import { useEffect } from 'react';
import history from '../history';
import { tripleWhalePageLoad } from 'utils/triple-whale';

// Fires a Triple Whale pageLoad event on the initial render and on every
// client-side (SPA) route change.
//
// history.listen() does not fire for the first render, and the pixel is installed
// with isHeadless:true, so nothing else reports the landing pageview — the one
// carrying the ad click id and referrer that attribution is built on.
const PageLoadTracker = () => {
    useEffect(() => {
        tripleWhalePageLoad();

        const unlisten = history.listen(() => tripleWhalePageLoad());
        return () => unlisten();
    }, []);

    return null;
};

export default PageLoadTracker;
